export { default as Hero } from './Hero'
export { default as Features } from './Features'
export { default as CloudMonitoring } from './CloudMonitoring'
export { default as IsReady } from './IsReady'
export { default as Migrate } from './Migrate'
export { default as DevOps } from './DevOps'
export { default as Resources } from './Resources'
